import { Grid, Button } from '@mui/material';
import { GroupOutlined, SendOutlined } from '@mui/icons-material';
import React, { useContext } from 'react';
import UserContext from './context/UsersContext';
import HeaderWithIcon from '../general/header/HeaderWithIcon';
import { StyledWhiteButton } from '../general/button/Styles';
import { UsersViewTitles } from './constant/UsersViewTitles.enum';

const UsersHeader: React.FC = () => {
    const { header, setHeader } = useContext(UserContext);

    const onClickCancelButton = () => {
        switch (header.title) {
            case UsersViewTitles.InviteUsers:
                setHeader({
                    title: UsersViewTitles.Users,
                    Icon: GroupOutlined,
                });
                break;
            case UsersViewTitles.InviteUsersViaEmail:
            case UsersViewTitles.InviteUsersViaCSV:
                setHeader({
                    title: UsersViewTitles.InviteUsers,
                    Icon: SendOutlined,
                });
                break;
            default:
                break;
        }
    };

    const onClickInviteButton = () => {
        setHeader({
            title: UsersViewTitles.InviteUsers,
            Icon: SendOutlined,
        });
    };

    return (
        <Grid
            item
            xs={12}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <HeaderWithIcon title={header.title} Icon={header.Icon} />
            {header.title === UsersViewTitles.Users ? (
                <Button
                    onClick={() => onClickInviteButton()}
                    endIcon={<SendOutlined />}
                    variant="contained"
                    color="success"
                    sx={{
                        p: '8px 15px',
                        height: '38px',
                    }}
                >
                    Invite
                </Button>
            ) : (
                <StyledWhiteButton
                    onClick={() => onClickCancelButton()}
                    style={{ backgroundColor: '#ffff', height: '38px' }}
                >
                    {header.title === UsersViewTitles.InviteUsersViaEmail
                        ? 'Back'
                        : 'Cancel'}
                </StyledWhiteButton>
            )}
        </Grid>
    );
};

export default UsersHeader;
